
// ==========================================  
// 8. src/components/sections/HowItWorks.js
// ==========================================
import React from 'react';
import SectionHeader from '../common/SectionHeader';

const Step = ({ number, title, description, timeline, isLast }) => (
  <div className="flex gap-6 items-start">
    <div className={`flex-shrink-0 w-16 h-16 ${
      isLast 
        ? 'bg-gradient-to-br from-blue-600 to-green-500' 
        : 'bg-blue-600'
    } rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg z-10`}>
      {number}
    </div>
    <div className={`flex-1 ${
      isLast 
        ? 'bg-gradient-to-br from-green-50 to-emerald-50 border-2 border-green-200' 
        : 'bg-white shadow-md'
    } rounded-xl p-6`}>
      <h3 className="text-2xl font-bold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-600 mb-3">{description}</p>
      <p className={`text-sm font-medium ${isLast ? 'text-green-600' : 'text-blue-600'}`}>
        {timeline}
      </p>
    </div>
  </div>
);

const HowItWorks = () => {
  const steps = [
    {
      number: 1,
      title: 'Map',
      description: 'We align on your lanes, integrations, rules, and KPIs. No cookie-cutter approach—we understand YOUR operation.',
      timeline: 'Timeline: 1-3 days'
    },
    {
      number: 2,
      title: 'Connect',
      description: 'Connect your ELD/GPS, sync carriers and customers, set your routing rules. We handle the complexity.',
      timeline: 'Timeline: 3-5 days'
    },
    {
      number: 3,
      title: 'Launch & Scale',
      description: 'Go live, measure outcomes, expand automation. Start with one route, scale to your entire fleet.',
      timeline: "You're operational in under 2 weeks",
      isLast: true
    }
  ];

  return (
    <section id="how" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader 
          title="Three Steps to Transform Your Operations"
          subtitle="No lengthy implementations. No disruption. Just results."
        />

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Connection Line */}
            <div className="absolute left-8 top-12 bottom-12 w-0.5 bg-gradient-to-b from-blue-200 via-blue-400 to-blue-600 hidden md:block"></div>
            
            <div className="space-y-8">
              {steps.map((step) => (
                <Step key={step.number} {...step} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;